import amanecer from "../assets/backgrounds/amanecer.webp";
import mañana from "../assets/backgrounds/mañana.webp";
import noche from "../assets/backgrounds/noche.webp";
import tarde from "../assets/backgrounds/tarde.webp";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { useEffect, useState } from "react";
import Notification from "./ui-elements/Notification";
import { useNavigate } from "react-router-dom";
import { isGreater, isWithinRange, parseTime } from "../utils/timeFuncs";

const images = {
  Madrugada: amanecer,
  Mañana: mañana,
  Noche: noche,
  Tarde: tarde,
};

const timeRanges = {
  Madrugada: { start: "04:00 AM", end: "05:59 AM" },
  Mañana: { start: "06:00 AM", end: "11:59 AM" },
  Tarde: { start: "12:00 PM", end: "05:59 PM" },
  Noche: { start: "06:00 PM", end: "08:30 PM" },
};

const TimeCard = ({ text }) => {
  const imageSrc = images[text] || amanecer;

  const [isActive, setIsActive] = useState(false);
  const [lateReg, setLateReg] = useState(false);

  const checkActiveStatus = () => {
    const currentHour = new Date().toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    const currentTime = parseTime(currentHour);
    const { start, end } = timeRanges[text] || {};
    const activeStatus =
      start && end ? isWithinRange(currentTime, start, end) : false;
    setIsActive(activeStatus);
    const timeIsGreater = isGreater(currentTime, end);
    setLateReg(timeIsGreater);
  };

  const navigate = useNavigate();

  useEffect(() => {
    checkActiveStatus();
    const interval = setInterval(() => {
      checkActiveStatus();
    }, 1000);
    return () => clearInterval(interval);
  }, [text]);

  return (
    <div className="flex flex-col shadow-lg rounded-lg h-fit md:m-4 m-2">
      <div className="relative flex flex-col items-center bg-white shadow-md rounded-t-lg">
        <img
          src={imageSrc}
          alt={`${text}-image`}
          className="w-full h-48 rounded-t-lg object-cover"
        />
        {!isActive && !lateReg && (
          <AiOutlineInfoCircle
            className="absolute top-3 right-3 hover:cursor-pointer bg-white text-accent-green rounded-full"
            size={18}
            onClick={() =>
              Notification({
                title: "Ups! Registro deshabilitado",
                text: "Debes hacer tu registro según el horario prestablecido",
                type: "Info",
              })
            }
          />
        )}
        {!isActive && lateReg && (
          <AiOutlineInfoCircle
            className="absolute top-3 right-3 hover:cursor-pointer bg-white text-accent-green rounded-full"
            size={18}
            onClick={() =>
              Notification({
                title: "Registro tardío",
                text: "Puedes realizar registros fuera de horario pero se registrarán como tardíos",
                type: "Info",
              })
            }
          />
        )}
      </div>

      <div className="flex flex-col py-4 bg-white px-4 justify-center gap-2 rounded-b-lg items-center">
        <h1 className="text-2xl font-bold font-poppins">{text}</h1>
        <span className="font-poppins">
          {text === "Madrugada" && (
            <>
              Se toma entre las{" "}
              <span className="font-bold text-dark-green">4 am a 5:59 am</span>
            </>
          )}
          {text === "Mañana" && (
            <>
              Se toma entre las{" "}
              <span className="font-bold text-dark-green">6 am a 11:59 am</span>
            </>
          )}
          {text === "Tarde" && (
            <>
              Se toma entre las{" "}
              <span className="font-bold text-dark-green">12 pm a 5:59 pm</span>
            </>
          )}
          {text === "Noche" && (
            <>
              Se toma entre las{" "}
              <span className="font-bold text-dark-green">6 pm a 8:30 pm</span>
            </>
          )}
        </span>
        <button
          className={`flex rounded-full font-poppins px-8 py-3 text-white mt-3 ${
            !isActive && !lateReg
              ? "bg-default-gray cursor-not-allowed"
              : !isActive && lateReg
              ? "bg-[#fea930] hover:bg-[#ffc736]"
              : "bg-dark-green hover:bg-accent-green"
          }`}
          disabled={!isActive && !lateReg}
          onClick={() => navigate(text)}
        >
          {!isActive && !lateReg
            ? "Deshabilitado"
            : !isActive && lateReg
            ? "Registrar"
            : "Registrar"}
        </button>
      </div>
    </div>
  );
};

export default TimeCard;
